/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { MessagingChannelType } from 'cio/utils/setup-guide/messaging-channels';
import MessagingChannelSetup from 'cio/components/setup-guide/channels/messaging/setup';

export default class SetupGuideMessagingSlackComponent extends MessagingChannelSetup {
  channel = MessagingChannelType.Slack;
  showSuccessAlert = true;
}
